import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addeventReturn from "./components/addeventReturn";
import { callbackTypeEventRuleManageData, callbackTypeEventRuleManageDel, callbackSwitchConfigManageData as _callbackSwitchConfigManageData, eventManageData } from "@/api/financial/backhaul";
import backhaul from "./mixins/backhaul";
import { serchSelect } from "@/mixins/index";
import parameterPopupTherr from "./components/parameterPopupTherr";
export default {
  name: "eventReturn",
  mixins: [backhaul, serchSelect],
  components: {
    addeventReturn: addeventReturn,
    parameterPopupTherr: parameterPopupTherr
  },
  data: function data() {
    return {
      tableData: [],
      reqLoading: false,
      total: 0,
      eventManageDataList: [],
      searchData: {
        switch_config_id: "",
        event_id: ''
      }
    };
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    comInit: function comInit() {
      this.callbackSwitchConfigManageData(); //this.getcallbackSwitchConfigManageData()
      // this.gettes()
    },
    callbackSwitchConfigManageData: function callbackSwitchConfigManageData() {
      var _this = this;

      if (!this.searchData.special_product_id || !this.searchData.special_product_id.toString()) {
        this.searchData.special_product_id_all = this.productsList.map(function (i) {
          return i.id;
        });
      } else {
        this.searchData.special_product_id_all = this.searchData.special_product_id;
      }

      _callbackSwitchConfigManageData(_objectSpread(_objectSpread({}, this.searchData), {}, {
        product_id: this.searchData.special_product_id_all
      })).then(function (res) {
        if (res.status == 200) {
          _this.callbackSwitchConfigData = res.data; // this.total = res.data.total
        }
      }).finally(function () {});
    },
    callbackSwitch: function callbackSwitch(e) {
      var _this2 = this;

      this.eventManageDataList = [];
      this.searchData.event_id = "";
      console.log("e===", e);
      var data = this.callbackSwitchConfigData.find(function (i) {
        return i.id == e;
      });
      eventManageData({
        advert_channel_id: data.advert_channel_id
      }).then(function (res) {
        if (res.status == 200) {
          _this2.eventManageDataList = res.data;
        }
      });
    },
    searchClick: function searchClick(e) {
      var _this3 = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      // if(!this.searchData.switch_config_id){
      //   this.$message.error('请选择产品绑定广告渠道')
      //   return
      // }
      this.searchData.page = e;
      this.reqLoading = true;
      var switchIds = [];

      if (!this.searchData.switch_config_id) {
        this.callbackSwitchConfigData.forEach(function (item) {
          switchIds.push(item.id);
        });
      } else {
        switchIds.push(this.searchData.switch_config_id);
      }

      callbackTypeEventRuleManageData(_objectSpread(_objectSpread({}, this.searchData), {}, {
        switch_config_id: switchIds.toString()
      })).then(function (res) {
        if (res.status == 200) {
          _this3.tableData = res.data;
        }
      }).finally(function () {
        _this3.reqLoading = false;
      });
    },
    handleDelete: function handleDelete(row) {
      var _this4 = this;

      this.$confirm("此操作将删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var id, switch_config_id, event_mark;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = row.id, switch_config_id = row.switch_config_id, event_mark = row.event_mark;
                callbackTypeEventRuleManageDel({
                  id: id.toString(),
                  switch_config_id: switch_config_id,
                  event_mark: event_mark
                }).then(function (res) {
                  if (res.status == 200) {
                    _this4.searchClick();

                    _this4.$message({
                      type: "success",
                      message: "删除成功!"
                    });
                  }
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })));
    }
  }
};